import BaseAuthClient from './baseAuth';

class OssClient extends BaseAuthClient {
  constructor() {
    super({ baseURL: '/api' });
  }
}

const ossClient = new OssClient();

// 获取游戏授权sts
export const getComicUploadImageSts = (option: any) => ossClient.get(`/v1/huawei/getnewcommonsts`, option);

export default ossClient;


